import { IAction } from '@/redux/actions/action-helpers'
import { ModalErrorTypes } from '@/redux/actions/actions.types'
import { EmptyVoidCallback } from '@/travelsuit/callback'

export const Actions = {
	clean(callback?: EmptyVoidCallback, errCallback?: IAction['errCallback']): IAction {
		return {
			type: ModalErrorTypes.Clean.SUCCESS,
			callback,
			errCallback,
		}
	},
}
